export enum OddsApiRegions {
    US = "US"
}